import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { pipeConfigsPropTypes } from 'common/propTypes';
import BgBlink from 'common/components/BgBlink';
import {
  indicatorsTypes, DOUBLE_COL_SPAN, NO_COL_SPAN, SUB_TITLE
} from 'ui/run/RunShow/config';
import { getFormattedIndicatorsData } from '../helper';
import { triggerExternalSignalManually } from 'common/api/externalSignal';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';

const propTypes = {
  pipeConfigs: pipeConfigsPropTypes.isRequired,
  tockGroup: PropTypes.shape({}).isRequired,
  instrumentGroup: PropTypes.arrayOf(PropTypes.string).isRequired,
  indicatorsType: PropTypes.string.isRequired,
  runStatus: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired,
  isOwnRun: PropTypes.bool
};

const getIndicatorDataTdProps = (subIndicatorKey, indicatorsType) => {
  if (indicatorsType === indicatorsTypes.pair) {
    return {
      className: subIndicatorKey === SUB_TITLE ? 'text-right' : 'text-center',
      colSpan: subIndicatorKey === SUB_TITLE ? NO_COL_SPAN : DOUBLE_COL_SPAN
    };
  }

  return { className: 'text-right' };
};


const IndicatorsDataTable = (props) => {
  const { indicatorsType, runStatus, jobId, isOwnRun = false } = props;
  const indicatorsData = getFormattedIndicatorsData(props);

  const renderExternalSignalTriggerButton = (token) => {
    const isDisabled = runStatus !== 'started';
    const tooltip = isDisabled
      ? 'Manual Trigger button only triggers signals for this run. Run must be in started to trigger signal.'
      : 'Manual Trigger button only triggers signals for this run.';

    return (
      <div className="d-inline-flex align-items-center">
        <button
          type="button"
          className="btn btn-sm btn-outline-danger btn-pill"
          onClick={() => {
            if (isDisabled) return;
            triggerExternalSignalManually(token, jobId)
              .then(() => {
                reactToastify(
                  'External signal triggered',
                  TOASTIFY_TYPES.INFO,
                  { autoClose: 2000, onClose: () => window.location.reload() }
                );
              })
              .catch(() => {
                reactToastify('Error triggering external signal', TOASTIFY_TYPES.ERROR, { autoClose: 3000 });
              });
          }}
          disabled={isDisabled}
        >
          Trigger Signal
        </button>
        <i className="fas fa-info-circle text-muted ms-2 cursor-pointer" data-toggle="tooltip" title={tooltip}></i>
      </div>
    );
  };
  
  const renderValues = (subIndicatorData) => {
    if (!_.isEmpty(subIndicatorData?.externalToken)) {
      if (isOwnRun) {
        return renderExternalSignalTriggerButton(subIndicatorData?.externalToken);
      }
      // For non-owner users, show a placeholder instead of the object
      return '-';
    }

    return _.isNumber(subIndicatorData) ? _.round(subIndicatorData, 2) : subIndicatorData;
  };

  if (_.isEmpty(indicatorsData)) return null;

  return (
    <>
      {_.map(indicatorsData, (data) => {
        const { title, indicatorData } = data;
        const titleRowSpan = indicatorData.length;
        const titleColSpan = indicatorData.length === 1 ? DOUBLE_COL_SPAN : NO_COL_SPAN;

        return _.map(indicatorData, (subIndicatorsData, idx) => (
          <tr key={`${title}-${idx}`}>
            {!idx && (
              <td rowSpan={titleRowSpan} colSpan={titleColSpan}>
                {title}
              </td>
            )}
            {_.map(subIndicatorsData, (subIndicatorData, key) => (
              <td key={key} {...getIndicatorDataTdProps(key, indicatorsType)}>
                <BgBlink>
                  {renderValues(subIndicatorData)}
                </BgBlink>
              </td>
            ))}
          </tr>
        ));
      })}
    </>
  );
};

IndicatorsDataTable.propTypes = propTypes;

export default React.memo(IndicatorsDataTable);
